import { render, staticRenderFns } from "./GMenus.vue?vue&type=template&id=2a48f40f&"
import script from "./GMenus.vue?vue&type=script&lang=js&"
export * from "./GMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports